import bar from './bar'
import style from '../style'

/**
 * Determines the available loader types.
 */
export type LoaderType = 'bar'

/**
 * Determines the options of the loader.
 */
export interface LoaderOptions {
  /**
   * Determines the color of the loader.
   */
  color: string

  /**
   * Determines the size of the loader.
   */
  size: [number, number]

  /**
   * Determine the loader type.
   */
  type: LoaderType

  /**
   * Determines the text color of the loader.
   */
  textColor: string

  /**
   * Determine the text to show.
   */
  text: string
}

/**
 * Determines the available loaders.
 */
const loaders = {
  bar,
}

/**
 * Creates the loader given the options.
 */
export const loader = (options: LoaderOptions) => `
    <div style="${style.chartisanHelpBlock}">
        ${loaders[options.type](options)}
        ${
          options.text != ''
            ? `
                <div style="color: ${options.textColor}; ${style.chartisanHelpText}">
                    ${options.text}
                </div>`
            : ''
        }
    </div>
`
